export default __webpack_public_path__ + "6d29ab801c7d197d3138c60cc752e79c.svg";